document.addEventListener('DOMContentLoaded', () => {
  const input  = document.querySelector('[data-member-number]');
  const button = document.querySelector('[data-request-member-number]');
  if (!input || !button) return;

  // lille statuslabel under feltet
  const status = document.createElement('div');
  status.setAttribute('aria-live', 'polite');
  status.style.marginTop = '6px';
  status.style.fontSize  = '0.9rem';
  input.parentElement.insertAdjacentElement('afterend', status);

  const setStatus = (msg, ok) => {
    status.textContent = msg;
    status.style.color = ok ? '#067d62' : '#d72c0d';
  };

  const validate = (value) => /^\d{6,7}$/.test(value.trim());

  // Klik på knappen
  button.addEventListener('click', () => {
    const value = input.value.trim();
    if (!value) {
      setStatus('Indtast dit medlemsnummer.', false);
      input.focus();
      return;
    }
    if (!validate(value)) {
      setStatus('Ugyldigt medlemsnummer. Indtast 6 eller 7 cifre.', false);
      return;
    }
    // Kun kosmetisk feedback – ingen opdatering af kurv/attributter
    setStatus('Medlemsnummer valideret ✔', true);
  });

  // Enter i feltet gør det samme som klik
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      button.click();
    }
  });

  // Ryd status når der skrives igen
  input.addEventListener('input', () => {
    status.textContent = '';
  });
});
